window.CROWN_POLICY_CONTENT = {
  "it": [
    [
      "destinations",
      "Destinazioni e costi di spedizione",
      [
        "Spediamo dall’Italia verso le destinazioni abilitate al checkout. La disponibilità del servizio viene verificata in base all’indirizzo di consegna.",
        "<strong>Italia</strong><br>Spedizione standard: €6,90.<br>Spedizione standard gratuita per ordini da €150.",
        "<strong>Unione europea, esclusa Italia</strong><br>Spedizione standard: €14,90.<br>Spedizione standard gratuita per ordini da €250.",
        "<strong>Stati Uniti</strong><br>Il costo di spedizione viene calcolato in base alla destinazione e mostrato prima del pagamento.",
        "Le soglie di gratuità si riferiscono al valore degli articoli dopo l’applicazione di eventuali sconti, escluse le spese di spedizione. Il totale dell’ordine, comprensivo degli importi applicabili, viene mostrato prima della conferma dell’acquisto.",
        "Eventuali limitazioni territoriali sono indicate prima del pagamento."
      ]
    ],
    [
      "delivery",
      "Preparazione e consegna",
      [
        "Per gli articoli disponibili a magazzino, la preparazione dell’ordine richiede normalmente 1–2 giorni lavorativi.",
        "Dall’affidamento al corriere, i tempi di trasporto stimati sono:",
        "<ul><li>Italia: 2–4 giorni lavorativi.</li><li>Unione europea: 3–6 giorni lavorativi.</li><li>Stati Uniti: 4–8 giorni lavorativi.</li></ul>",
        "I giorni lavorativi escludono sabati, domeniche e festività pertinenti.",
        "Riceverai una comunicazione con il collegamento per seguire la spedizione. I tempi sono indicativi e possono variare in base alla destinazione e alle operazioni di trasporto o sdoganamento, fatti salvi i tuoi diritti.",
        "Per i prodotti in preordine o con disponibilità futura, il termine di spedizione specifico è indicato nella scheda prodotto e prima dell’acquisto.",
        "Se non possiamo spedire entro il termine concordato, ti contatteremo per proporti una nuova data e raccogliere il tuo consenso oppure procedere all’annullamento e al rimborso della merce non spedita."
      ]
    ],
    [
      "usa",
      "Ordini destinati agli Stati Uniti",
      [
        "Per le spedizioni USA abilitate, gli eventuali dazi, le imposte e gli oneri d’importazione applicabili sono inclusi nel totale mostrato prima del pagamento.",
        "CROWN ne gestisce il pagamento e lo sdoganamento tramite il servizio di spedizione utilizzato. Non sono previsti ulteriori addebiti doganali alla consegna."
      ]
    ],
    [
      "return-period",
      "30 giorni per comunicare il reso",
      [
        "CROWN offre una politica commerciale di reso di 30 giorni di calendario dalla consegna.",
        "Per usufruirne, comunicaci entro questo termine la tua volontà di restituire tutto l’ordine o alcuni articoli. Spedisci poi i prodotti entro 14 giorni di calendario dalla comunicazione. Conta la data di rispedizione, non quella di arrivo al nostro magazzino.",
        "Questa estensione commerciale si aggiunge ai diritti inderogabili previsti dalla legge applicabile e non li limita."
      ]
    ],
    [
      "start-return",
      "Come avviare un reso",
      [
        "Puoi comunicarci il reso attraverso la funzione <a href=\"#return-form\">“Avvia un reso / Esercita il diritto di recesso”</a> disponibile sul sito oppure scrivendo a <a href=\"mailto:assistenza@crown-luxury-store.com\">assistenza@crown-luxury-store.com</a>.",
        "Indica il tuo nome, il numero d’ordine o altri elementi sufficienti a identificarlo e gli articoli che desideri restituire. La motivazione è facoltativa.",
        "Riceverai una conferma della comunicazione e le istruzioni per organizzare la restituzione.",
        "La comunicazione tempestiva è sufficiente per esercitare il diritto di recesso: un’eventuale successiva conferma organizzativa o un codice di reso non costituiscono un’autorizzazione da attendere.",
        "<strong>Indirizzo per la restituzione:</strong><br><span data-seller=\"returnAddress\"></span>",
        "Conserva la ricevuta di spedizione e, quando disponibile, il codice di tracciamento."
      ]
    ],
    [
      "return-costs",
      "Costi della restituzione",
      [
        "<strong>Ordini consegnati in Italia</strong><br>CROWN offre una spedizione di reso gratuita per ordine utilizzando l’etichetta fornita dal nostro servizio clienti. Puoi includere nello stesso pacco tutti gli articoli di quell’ordine che desideri restituire.",
        "Se scegli autonomamente un altro corriere, il costo è a tuo carico. Anche eventuali ulteriori spedizioni di reso dello stesso ordine restano a tuo carico, salvo i casi di difetto, non conformità o errore imputabile a CROWN.",
        "<strong>Ordini consegnati all’estero</strong><br>Il costo diretto del trasporto di restituzione è a carico del cliente. Puoi utilizzare un corriere a tua scelta oppure, se disponibile, richiedere un’etichetta CROWN.",
        "Il costo dell’eventuale etichetta CROWN viene comunicato prima dell’accettazione. Qualsiasi detrazione di tale costo dal rimborso richiede il tuo accordo preventivo.",
        "CROWN gestisce le istruzioni doganali necessarie per i resi internazionali e sostiene gli eventuali oneri amministrativi o doganali di reimportazione. Non applichiamo commissioni aggiuntive di gestione o riassortimento."
      ]
    ],
    [
      "care",
      "Prova e cura degli articoli",
      [
        "Puoi provare il capo nella misura necessaria a verificarne taglia, caratteristiche e vestibilità.",
        "Ti chiediamo di conservarne cartellini, accessori e confezione e di evitare utilizzi ulteriori rispetto alla prova, lavaggi o alterazioni.",
        "Per i capi Sculpt e gli articoli con body interno, effettua la prova sopra il tuo intimo personale e conserva le eventuali protezioni igieniche.",
        "La semplice prova, l’apertura della confezione o la rimozione di un cartellino non determinano automaticamente la perdita del diritto di recesso. Un’eventuale diminuzione di valore dovuta a un uso eccedente la prova necessaria sarà valutata e motivata caso per caso."
      ]
    ],
    [
      "refunds",
      "Rimborsi",
      [
        "Rimborsiamo il prezzo effettivamente pagato per gli articoli restituiti e le imposte e gli oneri d’importazione riscossi da CROWN attribuibili a tali articoli. L’eventuale recupero doganale viene gestito da CROWN e non condiziona il rimborso al cliente.",
        "In caso di reso dell’intero ordine, rimborsiamo anche la consegna standard iniziale pagata. È escluso l’eventuale supplemento per un servizio di consegna più costoso scelto dal cliente.",
        "Per i resi parziali, rimborsiamo gli articoli restituiti e gli eventuali ulteriori importi dovuti. Non addebitiamo retroattivamente spese di spedizione perché il valore degli articoli trattenuti scende sotto la soglia di gratuità.",
        "Eseguiamo il rimborso senza indebito ritardo e comunque entro 14 giorni dalla comunicazione del reso, sullo stesso mezzo di pagamento, salvo diverso accordo espresso senza costi per te.",
        "Salvo che CROWN abbia offerto di ritirare direttamente i beni, possiamo attendere la ricezione degli articoli oppure la prova della loro rispedizione, considerando l’evento che si verifica per primo."
      ]
    ],
    [
      "exchanges",
      "Cambi di taglia o colore",
      [
        "Per scegliere una taglia o un colore diverso, puoi restituire l’articolo e inoltrare un nuovo ordine, secondo disponibilità.",
        "Il nuovo acquisto segue le condizioni di spedizione mostrate al checkout."
      ]
    ],
    [
      "issues",
      "Articoli errati, difettosi o non conformi",
      [
        "Se ricevi un articolo diverso da quello ordinato, difettoso o non conforme, contattaci a <a href=\"mailto:assistenza@crown-luxury-store.com\">assistenza@crown-luxury-store.com</a> indicando il numero d’ordine e descrivendo il problema. Eventuali fotografie possono aiutarci a gestire la segnalazione.",
        "CROWN sostiene i costi necessari alla relativa gestione secondo i diritti applicabili. Questi casi non consumano il beneficio della spedizione di reso gratuita previsto per gli ordini italiani.",
        "Il termine commerciale di 30 giorni non limita i diritti relativi alla garanzia legale e alla conformità dei prodotti."
      ]
    ],
    [
      "seller",
      "Assistenza e dati del venditore",
      [
        "CROWN è un marchio gestito da:",
        "<span data-seller=\"legalName\"></span><br>Partita IVA: <span data-seller=\"vat\"></span><br>Sede legale: <span data-seller=\"registeredAddress\"></span>",
        "Email assistenza: <a href=\"mailto:assistenza@crown-luxury-store.com\">assistenza@crown-luxury-store.com</a><br>Telefono: <span data-seller=\"phone\"></span>",
        "Restano sempre salvi i diritti inderogabili riconosciuti al consumatore dalla legge applicabile."
      ]
    ]
  ],
  "en": [
    [
      "destinations",
      "Shipping destinations and charges",
      [
        "We ship from Italy to destinations enabled at checkout. Service availability is checked against your delivery address.",
        "<strong>Italy</strong><br>Standard shipping: €6.90.<br>Complimentary standard shipping on orders of €150 or more.",
        "<strong>European Union, excluding Italy</strong><br>Standard shipping: €14.90.<br>Complimentary standard shipping on orders of €250 or more.",
        "<strong>United States</strong><br>Shipping charges are calculated according to your destination and displayed before payment.",
        "Free shipping thresholds apply to the value of the products after any discounts, excluding shipping charges. Your complete order total, including applicable charges, is displayed before you confirm your purchase.",
        "Any delivery restrictions are disclosed before payment."
      ]
    ],
    [
      "delivery",
      "Order processing and delivery",
      [
        "In-stock orders are normally prepared within 1–2 business days.",
        "Estimated transit times after the parcel is handed to the carrier are:",
        "<ul><li>Italy: 2–4 business days.</li><li>European Union: 3–6 business days.</li><li>United States: 4–8 business days.</li></ul>",
        "Business days exclude Saturdays, Sundays and relevant public holidays.",
        "You will receive a shipping notification with a tracking link. Delivery estimates may vary depending on the destination, transport operations and customs clearance, without affecting your legal rights.",
        "For pre-orders and products with a future availability date, the specific shipping timeframe is displayed on the product page and before purchase.",
        "If we cannot dispatch your order within the agreed timeframe, we will contact you to propose a revised date and obtain your consent, or cancel and refund the unshipped products."
      ]
    ],
    [
      "usa",
      "Orders delivered to the United States",
      [
        "For enabled US deliveries, applicable duties, taxes and import charges are included in the total displayed before payment.",
        "CROWN arranges their payment and customs clearance through the shipping service used. No additional customs charges are due on delivery."
      ]
    ],
    [
      "return-period",
      "30 days to request a return",
      [
        "CROWN offers a commercial return period of 30 calendar days from delivery.",
        "Notify us within this period if you wish to return your entire order or selected products. Send the products back within 14 calendar days of your notification. The date of dispatch counts, rather than the date the parcel reaches our warehouse.",
        "This commercial policy is additional to your mandatory rights under applicable law and does not restrict them."
      ]
    ],
    [
      "start-return",
      "How to start a return",
      [
        "Use the <a href=\"#return-form\">“Start a return / Exercise your right of withdrawal”</a> function on our website, or email <a href=\"mailto:assistenza@crown-luxury-store.com\">assistenza@crown-luxury-store.com</a>.",
        "Please provide your name, order number or other information sufficient to identify your purchase, and the products you wish to return. Providing a reason is optional.",
        "We will acknowledge your notification and provide instructions to organise the return.",
        "A timely notification is sufficient to exercise an applicable right of withdrawal. Any subsequent logistical confirmation or return reference is not an approval you must wait for.",
        "<strong>Return address:</strong><br><span data-seller=\"returnAddress\"></span>",
        "Please keep your proof of dispatch and any tracking information."
      ]
    ],
    [
      "return-costs",
      "Return shipping costs",
      [
        "<strong>Orders delivered in Italy</strong><br>CROWN provides one complimentary return shipment per order when you use the label supplied by our customer service team. You may include all products you wish to return from that order in one parcel.",
        "If you independently choose another carrier, you are responsible for its charges. Any additional return shipments for the same order are also at your expense, except where a defect, non-conformity or error attributable to CROWN applies.",
        "<strong>Orders delivered outside Italy</strong><br>You are responsible for the direct cost of return shipping. You may use your own carrier or request a CROWN return label where available.",
        "The cost of a CROWN return label is disclosed before you accept it. Any deduction of that cost from your refund requires your prior agreement.",
        "CROWN provides the necessary customs instructions for international returns and covers any administrative or customs charges associated with re-importation. We do not charge additional handling or restocking fees."
      ]
    ],
    [
      "care",
      "Trying on and caring for your products",
      [
        "You may try on your item as necessary to assess its size, characteristics and fit.",
        "Please preserve its tags, accessories and packaging, and avoid wearing it beyond what is needed for a fitting, washing it or altering it.",
        "For Sculpt garments and products with an integrated bodysuit, try them on over your own underwear and preserve any hygiene protection provided.",
        "Trying on a product, opening its packaging or removing a tag does not automatically remove your statutory right of withdrawal. Any reduction in value caused by handling beyond what is necessary for a fitting will be assessed and explained individually."
      ]
    ],
    [
      "refunds",
      "Refunds",
      [
        "We refund the price paid for returned products and any taxes and import charges collected by CROWN that are attributable to those products. CROWN handles any recovery of customs charges, and your refund does not depend on that process.",
        "If you return your entire order, we also refund the standard original delivery charge you paid. Any additional amount for a more expensive delivery service you selected is excluded.",
        "For partial returns, we refund the returned products and any other amounts due. We do not retrospectively charge shipping because the value of the products you keep falls below the free shipping threshold.",
        "We issue refunds without undue delay and within 14 days of your return notification, using the original payment method unless you expressly agree otherwise at no cost to you.",
        "Unless CROWN has offered to collect the products directly, we may wait until we receive the products or evidence that you have sent them back, whichever occurs first."
      ]
    ],
    [
      "exchanges",
      "Size or colour changes",
      [
        "To choose a different size or colour, return your item and place a new order, subject to availability.",
        "The new order is subject to the shipping conditions displayed at checkout."
      ]
    ],
    [
      "issues",
      "Incorrect, faulty or non-conforming products",
      [
        "If you receive an incorrect, faulty or non-conforming product, contact <a href=\"mailto:assistenza@crown-luxury-store.com\">assistenza@crown-luxury-store.com</a> with your order details and a description of the issue. Photographs may help us resolve your request.",
        "CROWN covers the costs necessary to address these cases in accordance with your applicable rights. These cases do not use up the complimentary return shipment offered for Italian orders.",
        "The commercial 30-day return period does not limit your legal warranty or product conformity rights."
      ]
    ],
    [
      "seller",
      "Customer care and seller information",
      [
        "CROWN is a brand operated by:",
        "<span data-seller=\"legalName\"></span><br>VAT number: <span data-seller=\"vat\"></span><br>Registered office: <span data-seller=\"registeredAddress\"></span>",
        "Customer care email: <a href=\"mailto:assistenza@crown-luxury-store.com\">assistenza@crown-luxury-store.com</a><br>Telephone: <span data-seller=\"phone\"></span>",
        "Your mandatory rights under applicable consumer law remain unaffected."
      ]
    ]
  ]
};
